export default "__VITE_ASSET__KEjcF5QQ__"